import React from "react";

import { MyAccount } from "services/account/account.types";

const isLite = Boolean(process.env.REACT_APP_LITE);

export const AccountContext = React.createContext<{
  getAccount: () => MyAccount;
}>({
  getAccount: () =>
    isLite
      ? {
          id: "lite-dummy-id",
          accountName: "lite-dummy-name",
          region: "lite-dummy-region",
        }
      : ({} as MyAccount),
});
